import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { PlusSquare, Trash2, X as XIcon } from "react-feather";
import classNames from "classnames";
import Barcode from "react-barcode";
import Select from "react-select";

import {
  Button,
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import {
  addCell,
  brandsSuggestion,
  cellSuggestion,
  createNomenclature,
  generateBarcode,
  getCrossByArticleBrand,
  getNomenclatureOne,
  nomenclatureAddImages,
  nomenclatureRemoveImages,
  printBarcode,
  removeBarcode,
  removeCellFromNomenclature,
  removeNomenclatureProductGroup,
  updateNomenclature,
} from "services/api";
import { CloseButton } from "components/CloseButton";
import { MySpinner } from "components/MySpinner";
import { SelectSearch } from "components/SelectSearch";

import { Characteristics } from "features/Nomenclature/Characteristics";
import noImage from "assets/img/noimage.jpg";
import { Oem } from "features/Nomenclature/Oem";
import { Checkbox } from "components/Checkbox";
import { ChangeLogNomenclature } from "features/Nomenclature/ChangeLogNomenclature";
import { RelatedProducts } from "features/Nomenclature/ReleatedProducts";
import { TreeModal } from "features/Nomenclature/TreeModal";
import { AddCell } from "features/Nomenclature/AddCell";

import "./nomenclatureModal.scss";
import { Stock } from "features/Nomenclature/Stock";
import { AddCrossModal } from "features/Cross/AddCrossModal";
import { useNomenclatureModal } from "contexts/NomenclatureModalContext";

const PRICE_TYPES = [
  { value: "priceVrn", label: "Прайс Воронеж" },
  { value: "marketplacePriceVrn", label: "Прайс Опт Воронеж" }
];

const PRTINTERS = [
  { value: "Xprinter XP-420B1", label: "Xprinter XP-420B1" },
  { value: "TSC TDP-225", label: "TSC TDP-225" },
];

export const NomenclatureModal = ({
  getAndSetNomenclature,
}) => {
  const { openModal, nomenclatureId, closeNomenclatureModal } = useNomenclatureModal();
  const id = nomenclatureId;
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [article, setArticle] = useState("");
  const [brand, setBrand] = useState(null);
  const [name, setName] = useState("");
  const [barcode, setBarcode] = useState("");
  const [barcodes, setBarcodes] = useState([]);
  const [id1C, setId1C] = useState("");
  const [weight, setWeight] = useState("");
  const [length, setLength] = useState("");
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");
  const [minPrice, setMinPrice] = useState("");
  const [costPrice, setCostPrice] = useState("");
  const [fixPrice, setFixPrice] = useState("");
  const [marketplacePrice, setMarketplacePrice] = useState("");
  const [disableAutoUpdate, setDisableAutoUpdate] = useState(false);
  const [errors, setErrors] = useState([]);
  const [images, setImages] = useState([]);
  const [needValid, setNeedValid] = useState(true);
  const [selectedImage, setSelectedImage] = useState("");
  const inputImage = useRef();
  const [addedImages, setAddedImages] = useState([]);
  const [cell, setCell] = useState(null);
  const [cellTranzit, setCellTranzit] = useState(null);
  const [cells, setCells] = useState([]);
  const [cellsTranzit, setCellsTranzit] = useState([]);
  const [characteristicsValue, setCharacteristicsValue] = useState([]);
  const [countPrint, setCountPrint] = useState(1);

  const [relatedProducts, setRelatedProducts] = useState([]);
  const [site, setSite] = useState(false);
  const [productGroups, setProductGroups] = useState([]);
  // const [showNewCell, setShowNewCell] = useState(false);
  // const [newCell, setNewCell] = useState("");
  const [analogueCode, setAnalogueCode] = useState(null);
  const [prices, setPrices] = useState([]);
  const [price, setPrice] = useState("");
  const [priceType, setPriceType] = useState(null);
  const [shownPriceForm, setShownPriceForm] = useState(false);
  const [openTreeModal, setOpenTreeModal] = useState(false);
  const [printer, setPrinter] = useState(localStorage.getItem('articlePrinter')
    ? JSON.parse(localStorage.getItem('articlePrinter'))
    : null);
  const [multiplicity, setMultiplicity] = useState("");
  const [prohibitBreakingPackaging, setProhibitBreakingPackaging] = useState(false);

  const getAndSetNomenclatureOne = () => {
    if (!id) return;
    setLoading(true);
    getNomenclatureOne(id)
      .then((res) => {
        setActive(res.active);
        setArticle(res.article);
        setName(res.name);
        setBrand({
          label: res.brand?.name,
          value: res.brand?.id,
        });
        setId1C(res.id1C);
        setWeight(res.weight);
        setLength(res.size?.length);
        setWidth(res.size?.width);
        setHeight(res.size?.height);
        setMinPrice(res.minPrice);
        setCostPrice(res.costPrice);
        setFixPrice(res.fixPrice);
        setMarketplacePrice(res.marketplacePrice);
        setCells(res.cell.filter(v => v.type === 1));
        setCellsTranzit(res.cell.filter(v => v.type === 2));
        setDisableAutoUpdate(res.disableAutoUpdate);
        setImages(res.images || []);
        setCharacteristicsValue(res.characteristicsValue);
        setSite(res.site);
        setBarcodes(res.barcode);
        setProductGroups(res.productGroups);
        setRelatedProducts(res.relatedProducts);
        setPrices(res.price);
        setMultiplicity(res.multiplicity ?? "");
        setProhibitBreakingPackaging(res.prohibitBreakingPackaging ?? false);
      })
      .catch((e) => toast.error(e.response?.data?.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    setActive("");
    setArticle("");
    setName("");
    setBrand(null);
    setId1C("");
    setWeight("");
    setLength("");
    setWidth("");
    setHeight("");
    setMinPrice("");
    setCostPrice("");
    setFixPrice("");
    setMarketplacePrice("");
    setCell(null);
    setCells([]);
    setCellsTranzit([]);
    setDisableAutoUpdate("");
    setImages([]);
    setSelectedImage("");
    setBarcodes([]);
    setSite(false);
    setMultiplicity("");
    setProhibitBreakingPackaging(false);
    getAndSetNomenclatureOne();
    setPrices([]);
    setActiveTab("1");
  }, [id]);

  const editHandler = () => {
    setLoading(true);
    updateNomenclature({
      id,
      name,
      article,
      brand: brand?.value,
      id1C,
      active,
      weight,
      width,
      length,
      height,
      minPrice,
      fixPrice,
      price: prices,
      marketplacePrice,
      cell: cell?.value || "",
      cellTranzit: cellTranzit?.value || "",
      disableAutoUpdate,
      site,
      barcodes,
      multiplicity,
      prohibitBreakingPackaging,
    })
      .then((res) => {
        getAndSetNomenclatureOne();
        setCell(null);
        setCellTranzit(null);
        toast.success("Номенклатура успешно сохранена");

        if (getAndSetNomenclature) {
          getAndSetNomenclature();
        }
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
      });
  };

  const createHandler = () => {
    setLoading(true);
    createNomenclature({
      name,
      article,
      brand: brand.value,
      id1C,
      active,
      weight,
      width,
      length,
      height,
      minPrice,
      costPrice,
      price: prices,
      fixPrice,
      marketplacePrice,
      cell: cell?.value || "",
      disableAutoUpdate,
      site,
      barcodes
    })
      .then((res) => {
        getAndSetNomenclatureOne();
        toast.success("Номенклатура успешно создана");

        if (getAndSetNomenclature) {
          getAndSetNomenclature();
        }
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
      })
      .finally(() => setLoading(false));
  };

  const renderImage = () => {
    if (images.length > 0 && !selectedImage) {
      return (
        <img
          src={`${process.env.REACT_APP_BASE_URL}/image.view?file=${images[0].key}`}
          alt={name}
        />
      );
    }

    if (selectedImage) {
      return (
        <img
          src={`${process.env.REACT_APP_BASE_URL}/image.view?file=${selectedImage}`}
          alt={name}
        />
      );
    }

    return <img src={noImage} alt={name} />;
  };

  const getImages = () => {
    if (inputImage) {
      inputImage.current.click();
    }
  };

  useEffect(() => {
    if (!addedImages.length) return;
    const formData = new FormData();
    for (const image of addedImages) {
      formData.append("images[]", image);
    }
    formData.append("id", id);
    setAddedImages([]);
    setLoading(true);
    nomenclatureAddImages(formData)
      .then((res) => {
        getAndSetNomenclatureOne();
        toast.success("Изображения успешно добавлены");
        if (getAndSetNomenclature) {
          getAndSetNomenclature();
        }
      })
      .catch((e) => toast.error(e.response?.data?.message))
      .finally(() => setLoading(false));
  }, [addedImages]);

  useEffect(() => {
    localStorage.setItem('articlePrinter', JSON.stringify(printer));
  }, [printer]);

  const removeImage = (id) => {
    setLoading(true);
    nomenclatureRemoveImages({ id })
      .then((res) => {
        getAndSetNomenclatureOne();
        toast.success("Изображения успешно удалены");
        if (getAndSetNomenclature) {
          getAndSetNomenclature();
        }
      })
      .catch((e) => toast.error(e.response?.data?.message))
      .finally(() => setLoading(false));
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const removeProductGroup = (id) => {
    setLoading(true);
    removeNomenclatureProductGroup({ id })
      .then((res) => {
        getAndSetNomenclatureOne();
        toast.success("Товарная группа удалена из номенклатуры");
        if (getAndSetNomenclature) {
          getAndSetNomenclature();
        }
      })
      .catch((e) => toast.error(e.response?.data?.message));
  }

  const renderGroup = ([id, group]) => <div className="nomenclature-modal__group">
    {group.map((item) => (
      <span key={item.id} className="nomenclature-modal__category">
        {item.name}
      </span>
    ))}
    <Button onClick={() => removeProductGroup(id)}><Trash2 size={15} /></Button>
  </div>;

  // const addCellHandler = () => {
  //   const regex = /^\d{1,2}-[A-Za-z]-\d{1,2}$/;
  //   if (!regex.test(newCell)) {
  //     toast.error("Ячейка должна быть вида 9-A-9 или 99-A-99");
  //     return;
  //   }
  //   setLoading(true);
  //   addCell({ name: newCell })
  //     .then((res) => {
  //       toast.success("Ячейка успешно добавлена");
  //     })
  //     .catch((e) => toast.error(e.response?.data?.message))
  //     .finally(() => {
  //       setLoading(false);
  //       setShowNewCell(false);
  //     });
  // };

  const generateBarcodeHandler = () => {
    setLoading(true);
    generateBarcode({ id, barcode })
      .then((res) => {
        toast.success("Штрихкод успешно сохранен");
        setBarcodes(res.barcode);
      })
      .catch((e) => toast.error(e.response?.data?.message))
      .finally(() => {
        setLoading(false);
      });
  };

  const removeCell = (cellId) => {
    setLoading(true);
    removeCellFromNomenclature({ id: cellId })
      .then((res) => {
        toast.success("Ячейка успешно удалена");
        setCells(res.cell.filter(v => v.type === 1));
        setCellsTranzit(res.cell.filter(v => v.type === 2));
      })
      .catch((e) => toast.error(e.response?.data?.message))
      .finally(() => {
        setLoading(false);
      });
  };

  const priceAddHandler = () => {

  }

  const printLabelHandler = () => {
    printBarcode({
      id,
      count: countPrint,
      printer: printer?.value
    })
      .then((res) => {
        toast.success("Стикер отправлен на принтер");
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const removeBarcodeHandler = (id) => {
    setLoading(true);
    removeBarcode({ id })
      .then((res) => {
        toast.success("Штрихкод успешно удален");
        setBarcodes(res.barcode);
      })
      .catch((e) => toast.error(e.response?.data?.message))
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <Modal
      isOpen={openModal}
      toggle={closeNomenclatureModal}
      className="nomenclature-modal"
    >
      {loading && <MySpinner overlay />}
      <ModalHeader>
        <div className="modal-title-text">
          <div>
            {article} {brand?.label}
            <span className="nomenclature-modal__id">ID: {id}</span>
            <ChangeLogNomenclature
              id={id}
              className="nomenclature-modal__changelog"
            />
          </div>
          {name && (
            <div className="nomenclature-modal__name">
              {name}
            </div>
          )}
        </div>
        <CloseButton onClick={closeNomenclatureModal} />
      </ModalHeader>
      <ModalBody className="m-3">
        <Row className="main-info">
          <Col md="5">
            <div className="nomenclature-modal__image">{renderImage()}</div>
            <div className="nomenclature-modal__miniatures">
              {images.map((image) => (
                <div
                  className={classNames("nomenclature-modal__miniature", {
                    selected: image.key === selectedImage,
                  })}
                  key={image.id}
                  onClick={() => setSelectedImage(image.key)}
                >
                  <button
                    className="nomenclature-modal__remove"
                    onClick={() => removeImage(image.id)}
                  >
                    <XIcon color="white" size={13} />
                  </button>
                  <img
                    src={`${process.env.REACT_APP_BASE_URL}/image.view?file=${image.key}`}
                  />
                </div>
              ))}

              <button className="nomenclature-modal__add" onClick={getImages}>
                <PlusSquare size={20} color="gray" />
              </button>

              <Input
                type="file"
                id="images"
                multiple
                hidden
                innerRef={inputImage}
                onChange={(e) => setAddedImages(e.target.files)}
                accept=".jpeg,.jpg,.png"
              />
            </div>
            <div className="nomenclature-modal__barcode">
              {barcodes.length > 0 && (
                <div className="nomenclature-modal__barcode-img">
                  <div className="print">
                    <Barcode value={barcodes[0].barcode} format="CODE128" />
                  </div>
                  <div className="d-flex justify-content-center">
                    <Col md="2">
                      <Label>Кол-во</Label>
                      <Input
                        id="countPrint"
                        type="number"
                        value={countPrint}
                        onChange={(e) => setCountPrint(parseInt(e.target.value))}
                        className="nomenclature-modal__countPrint"
                      />
                    </Col>
                    <Col md="6">
                      <Label>Принтер</Label>
                      <Select
                        name="priceType"
                        placeholder="Тип цены"
                        className="react-select-container"
                        classNamePrefix="react-select"
                        options={PRTINTERS}
                        value={printer}
                        onChange={setPrinter}
                      />
                    </Col>

                    <Button onClick={printLabelHandler} className="nomenclature-modal__countPrintButton with-label">
                      Печать
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </Col>
          <Col md="7" className="tab">
            <Row className="mb-2">
              <Col>
                <Label>Выгружать на сайт</Label>
                <Checkbox
                  value="site"
                  name="site"
                  checked={site}
                  onChange={(e) => setSite(e.target.checked)}
                />
              </Col>
            </Row>
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classNames({
                    active: activeTab === "1",
                  })}
                  onClick={() => toggleTab("1")}
                >
                  Основные данные
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classNames({
                    active: activeTab === "2",
                  })}
                  onClick={() => toggleTab("2")}
                >
                  Характеристики
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classNames({
                    active: activeTab === "3",
                  })}
                  onClick={() => toggleTab("3")}
                >
                  Кроссы
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classNames({
                    active: activeTab === "4",
                  })}
                  onClick={() => toggleTab("4")}
                >
                  Сопутствующие товары
                </NavLink>
              </NavItem>
            </Nav>

            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                Код аналога: {analogueCode?.name}
                <Row>
                  <Col md="6">
                    <Label>Артикул</Label>
                    <Input
                      name="article"
                      placeholder="Артикул"
                      value={article}
                      onChange={(e) => setArticle(e.target.value)}
                      invalid={needValid && errors.hasOwnProperty("article")}
                    />
                  </Col>
                  <Col md="6">
                    <Label>Бренд</Label>
                    <SelectSearch
                      name="brand"
                      placeholder="Выберите бренд"
                      functionSuggestion={brandsSuggestion}
                      value={brand}
                      setValue={setBrand}
                      needValid={needValid}
                      errors={errors}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Label>Наименование</Label>
                    <Input
                      name="name"
                      placeholder="Наименование"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      invalid={needValid && errors.hasOwnProperty("name")}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Label>Вес, кг</Label>
                    <Input
                      name="weight"
                      placeholder="Вес, кг"
                      value={weight || ""}
                      onChange={(e) => setWeight(e.target.value)}
                    />
                  </Col>
                  <Col>
                    <Label>Длина, мм</Label>
                    <Input
                      name="length"
                      placeholder="Длина, мм"
                      value={length || ""}
                      onChange={(e) => setLength(e.target.value)}
                    />
                  </Col>
                  <Col>
                    <Label>Ширина, мм</Label>
                    <Input
                      name="width"
                      placeholder="Ширина, мм"
                      value={width || ""}
                      onChange={(e) => setWidth(e.target.value)}
                    />
                  </Col>
                  <Col>
                    <Label>Высота, мм</Label>
                    <Input
                      name="height"
                      placeholder="Высота, мм"
                      value={height || ""}
                      onChange={(e) => setHeight(e.target.value)}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Label>Кратность</Label>
                    <Input
                      type="number"
                      name="multiplicity"
                      placeholder="Кратность"
                      min={0}
                      value={multiplicity || ""}
                      onChange={(e) => setMultiplicity(e.target.value)}
                    />
                  </Col>
                  <Col className="d-flex align-items-end pb-2">
                    <Checkbox
                      id="prohibitBreakingPackaging"
                      name="prohibitBreakingPackaging"
                      checked={prohibitBreakingPackaging}
                      onChange={(e) => setProhibitBreakingPackaging(e.target.checked)}
                    >
                      Запрет вскрытия упаковки
                    </Checkbox>
                  </Col>
                </Row>
                <Row className="prices">
                  <Col md="3">
                    <Label>Себестоимость</Label>
                    <Input
                      name="costPrice"
                      placeholder="Себестоимость"
                      value={costPrice || ""}
                      onChange={(e) => setCostPrice(e.target.value)}
                      disabled
                    />
                  </Col>
                  <Col md="3">
                    <Label>Площадки</Label>
                    <Input
                      name="marketplacePrice"
                      placeholder="Площадки"
                      value={marketplacePrice || ""}
                      onChange={(e) => setMarketplacePrice(e.target.value)}
                    />
                  </Col>
                  <Col md="3">
                    <Label>Фикс цена</Label>
                    <Input
                      name="fixPrice"
                      placeholder="Фиксированая цена"
                      value={fixPrice || ""}
                      onChange={(e) => setFixPrice(e.target.value)}
                    />
                  </Col>

                  {prices.map(price =>
                    <Col md="3" key={price.type}>
                      <Label>{price.typeName}</Label>
                      <Input
                        name="price"
                        placeholder={price.typeName}
                        value={price.price || ""}
                        onChange={(e) => setPrices(prev => ({ ...prev, [price.type]: e.target.value }))}
                      />
                    </Col>
                  )}

                  <Button
                    className="price__add"
                    onClick={() => setShownPriceForm(true)}
                  >
                    +
                  </Button>

                  {shownPriceForm &&
                    <Row className="price__add-form">
                      <Col md="6">
                        <Label>Тип цены</Label>
                        <Select
                          name="priceType"
                          placeholder="Тип цены"
                          className="react-select-container"
                          classNamePrefix="react-select"
                          options={PRICE_TYPES}
                          value={priceType}
                          onChange={setPriceType}
                          isClearable
                        />
                      </Col>
                      <Col md="6">
                        <Label>Цена</Label>
                        <Input
                          name="price"
                          placeholder="price"
                          value={price}
                          onChange={(e) => setPrice(e.target.value)}
                        />
                      </Col>
                    </Row>
                  }

                </Row>
                <Row className="warehouse">
                  <Col md="5">
                    <Label>Ячейки</Label>
                    <div className="cellList">
                      {cells.map(cell =>
                        <div key={cell.id}>
                          {cell.name} <button onClick={() => removeCell(cell.id)}><XIcon width={13} /></button>
                        </div>
                      )}
                    </div>
                    <div className="cell d-flex">
                      <AddCell
                        cell={cell}
                        setCell={setCell}
                        setLoading={setLoading}
                      />
                    </div>

                    <Label className="mt-2">Ячейки транзит</Label>
                    <div className="cellList">
                      {cellsTranzit.map(cell =>
                        <div key={cell.id}>
                          {cell.name} <button onClick={() => removeCell(cell.id)}><XIcon width={13} /></button>
                        </div>
                      )}
                    </div>
                    <div className="cell d-flex">
                      <AddCell
                        cell={cellTranzit}
                        setCell={setCellTranzit}
                        setLoading={setLoading}
                        type={2}
                      />
                    </div>
                  </Col>

                  <Col md="7">
                    <Label>Штрихкод</Label>
                    <div className="barcodeWrapper">

                      {barcodes.length === 0 && <div>Штрихкодов нет</div>}

                      <div className="barcodeList">
                        {barcodes.map(barcode =>
                          <div key={barcode.id}>
                            {barcode.barcode}
                            <button onClick={() => removeBarcodeHandler(barcode.id)}><XIcon width={13} /></button>
                          </div>
                        )}
                      </div>
                      <span>введите штрихкод, или оставьте пустым, чтобы сгенерировать</span>
                      <div className="barcodeWrapper">
                        <Input
                          name="barcode"
                          placeholder="Штрихкод"
                          value={barcode || ""}
                          onChange={(e) => setBarcode(e.target.value)}
                        />

                        <Button
                          className="barcode__generate"
                          onClick={generateBarcodeHandler}
                        >
                          +
                        </Button>
                      </div>

                    </div>
                  </Col>
                </Row>
                <h5 className="mt-3">Товарные группы</h5>
                <Row>
                  <Col>{Object.entries(productGroups).map((group) => renderGroup(group))}</Col>
                </Row>
                <Row>
                  <Button onClick={() => setOpenTreeModal(true)}>Изменить группу</Button>
                </Row>
                <div className="d-flex justify-content-end mt-3">
                  <Button
                    onClick={id ? editHandler : createHandler}
                    color="primary"
                  >
                    Сохранить
                  </Button>
                </div>
              </TabPane>
              <TabPane tabId="2">
                <Characteristics
                  id={id}
                  setCharacteristicsValue={setCharacteristicsValue}
                  characteristicsValue={characteristicsValue}
                />
              </TabPane>
              <TabPane tabId="3">
                <Oem
                  activeTab={activeTab}
                  article={article}
                  brand={brand}
                  name={name}
                />
              </TabPane>
              <TabPane tabId="4">
                <RelatedProducts
                  id={id}
                  setLoading={setLoading}
                  relatedProducts={relatedProducts}
                  getAndSetNomenclatureOne={getAndSetNomenclatureOne}
                />
              </TabPane>
            </TabContent>
          </Col>
        </Row>

        <Stock
          id={id}
          activeTab={activeTab}
        />
        <TreeModal
          openModal={openTreeModal}
          setOpenModal={setOpenTreeModal}
          id={id}
          getAndSetNomenclatureOne={getAndSetNomenclatureOne}
        />
      </ModalBody>
    </Modal >
  );
};
